import { RouteProps } from 'react-router';
import { createStore } from 'redux';

import Entry from '@containers/entry/h5';
import Reward from '@containers/reward/h5';
import IdActivity from '@containers/reward/id-activity/h5';
import MagicEvent from '@containers/event/h5';
import Article from '@containers/article/h5';
import Post from '@containers/post/h5';
import Copyright from '@containers/copyright/h5';

// export const Home = loadable(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Home" */ '../containers/home'));

interface IRouteProps extends RouteProps {
    component: RouteProps['component'] & {
        loadData?: (ctx: any, store: ReturnType<typeof createStore>) => Promise<void>;
    };
}

export const routes: IRouteProps[] = [
    {
        path: ['/', '/home', '/native'],
        component: Entry,
        exact: true,
    },
    {
        path: '/reward',
        component: Reward,
        exact: true,
    },
    {
        path: '/reward/id-activity',
        component: IdActivity,
        exact: true,
    },
    {
        path: '/article/:id',
        component: Article,
        exact: true,
    },
    {
        path: '/post/:id',
        component: Post,
        exact: true,
    },
    // 魔方活动路由
    {
        path: '/event/:name',
        component: MagicEvent,
        exact: true,
    },
    {
        path: '/copyright',
        component: Copyright,
        exact: true,
    }
];
